import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Avatar, TextField, Typography, Autocomplete, AvatarGroup, Tooltip, Stack, Button } from '@material-ui/core';
//
import { MChip } from '../../@material-extend';
import SearchNotFound from '../../SearchNotFound';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import Modal from '../blog/ProjectModel';
import Scrollbar from 'src/components/Scrollbar';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 3)
}));

const AutocompleteStyle = styled('div')(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    minWidth: 280,
    marginLeft: theme.spacing(2),
    '&.Mui-focused .MuiAutocomplete-inputRoot': {
      boxShadow: theme.customShadows.z8
    }
  },
  '& .MuiAutocomplete-inputRoot': {
    transition: theme.transitions.create('box-shadow', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter
    }),
    '& fieldset': {
      borderWidth: `1px !important`,
      borderColor: `${theme.palette.grey[500_32]} !important`
    }
  }
}));

// ----------------------------------------------------------------------

JobNoteMessageHeader.propTypes = {
  contacts: PropTypes.array,
  recipients: PropTypes.array,
  onAddRecipient: PropTypes.func
};

export default function JobNoteMessageHeader({ contacts,contactss,adminData, recipients, onAddRecipient, ...other }) {
  const [query, setQuery] = useState('');
  const user = JSON.parse(localStorage.getItem('user'))
  const userType = user?.user_type
  const userId = user?.user_id
  const [opens, setOpens] = useState(false);
  const handleChangeQuery = (event) => {
    setQuery(event.target.value);
  };
  const handleOpens = () => {
    console.log('Avatar clicked');
    setOpens(true);
  };

  const handleCloses = () => {
    console.log('close clicked');
    setOpens(false);
  };
  const toAllUsers = contactss?.filter((user)=>user?.user_id !== userId)

const handleAddRecipient = (e, selectedRecipients) => {
  setQuery('');
  if (onAddRecipient) {
    onAddRecipient(selectedRecipients); // pass array
  }
};

  return (
    <RootStyle {...other}>
      <Typography variant="subtitle2" sx={{ mr:1 }}>
        To:
      </Typography>
      <AvatarGroup >
        {toAllUsers?.slice(0, 4).map((row) => (
          <Tooltip key={row.id} title={row.name || 'No Name Provided'}>
            <Avatar src={row.profile_pic} alt={row.name} />
          </Tooltip>
        ))}
        {toAllUsers?.length > 4 && (
          <Tooltip title="Show all">
            <Avatar
              onClick={handleOpens}
              style={{ cursor: 'pointer', backgroundColor: '#c8e6c9' }}
            >
              +{toAllUsers.length - 4}
            </Avatar>
          </Tooltip>
        )}
      </AvatarGroup>
      {/* Modal to show all avatars */}
      <Modal open={opens} handleClose={handleCloses}>
        <Box>
          <Typography variant="h6" gutterBottom>
            All Members
          </Typography>
          <Scrollbar sx={{ height: '350px' }}>
            <Stack spacing={2}>
              {toAllUsers?.map((row) => (
                <Stack key={row.id} direction="row" spacing={2} alignItems="center">
                  <Avatar src={row.profile_pic} alt={row.name} />
                  <Typography variant="body1">{row.name || 'No Name Provided'}</Typography>
                </Stack>
              ))}
            </Stack>
          </Scrollbar>
          <Button
            variant="contained"
            onClick={handleCloses}
            sx={{ mt: 2, display: 'block', ml: 'auto' }}
          >
            Close
          </Button>
        </Box>
      </Modal>

      <AutocompleteStyle>    
          {
        //   (userType == 1) ? (
        //     clientData ? (
        //       <Box display="flex" alignItems="center" gap={1}>
        //         <Avatar src={clientData.profile_pic} alt={clientData.name} />
        //         <Typography>{clientData.name}</Typography>
        //       </Box>
        //     ) : (
        //       <Typography>No client found</Typography>
        //     )
        //   ) : (userType == 3) ? (
        //     adminData ? (
        //       <Box display="flex" alignItems="center" gap={1}>
        //         <Avatar src={adminData?.profile_pic} alt={`${adminData?.first_name} ${adminData?.last_name}`} />
        //         <Typography>{`${adminData?.first_name} ${adminData?.last_name}`}</Typography>
        //       </Box>
        //     ) : (
        //       <Typography>Admin</Typography>
        //     )
        //   ) : (clientData || adminData ? (
        //     <Box display="flex" alignItems="center" gap={2}>
        //       {clientData ?
        //       <Box display="flex" alignItems="center" gap={1}>
        //         <Avatar src={clientData.profile_pic} alt={clientData.name} />
        //         <Typography>{clientData.name}</Typography>
        //       </Box> : ''}
        //       {adminData ? 
        //       <Box display="flex" alignItems="center" gap={1}>
        //         <Avatar src={adminData.profile_pic} alt={`${adminData.first_name} ${adminData.last_name}`} />
        //         <Typography>{`${adminData.first_name} ${adminData.last_name}`}</Typography>
        //       </Box> : ''}
        //     </Box>
        //   ) : (
        //     <Typography>Admin</Typography>
        //   ))
        // (userType !== 1 && userType !== 8) ?
        // adminData ? (
        //       <Box display="flex" alignItems="center" gap={1}>
        //         <Avatar src={adminData?.profile_pic} alt={`${adminData?.first_name} ${adminData?.last_name}`} />
        //         <Typography>{`${adminData?.first_name} ${adminData?.last_name}`}</Typography>
        //       </Box>
        //     ) : (
        //       <Typography>Admin</Typography>
        //     )
        // :
            // <Autocomplete
            //   fullWidth           
            //   size="small"
            //   multiple
            //   options={toAllUsers}
            //   disableCloseOnSelect
            //   value={toAllUsers}
            //   // value={values.clients}
            //   onChange={handleAddRecipient}
            //   //  onChange={(event, newValue) =>{console.log(newValue), setFieldValue('clients', newValue)}}
            //   getOptionLabel={(option) => option.name}
            //   renderOption={(props, option, { selected }) => (
            //     <li {...props}>
            //       {/* <Checkbox
            //         sx={{ width: '24px', height: '24px' }}
            //         checked={selected}
            //       /> */}
            //       <Avatar src={option.profile_pic} alt={option.name} sx={{mr:1}} />
            //       {option.name}
            //     </li>
            //   )}
            //   renderInput={(params) => (
            //     <TextField {...params} label="Choose" placeholder="Choose" />
            //   )}
            // />
        }
      </AutocompleteStyle>
    </RootStyle>
  );
}
